/* eslint-disable react/prop-types */
import { useEffect, useRef } from "react";
import { BrowserRouter } from "react-router-dom";
import App from "App";
import { ErrorBoundary } from "react-error-boundary";

import { enableErrorLog } from "./services/config";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

// Kaizen Dashboard Context Provider
import { SoftUIControllerProvider, MessageManagerProvider } from "context";
import { UserProvider } from "context/user";

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);
function ErrorLog({ error }) {
  const enviado = useRef(false);

  let errorObj = {
    error: error.message,
    errorInfo: {
      message: error.message,
      component: error.stack.toString().split("at ")[1].split(" (")[0],
    },
    descripcion: "Error generado automaticamente",
    idUser: JSON.parse(localStorage.getItem("user")).id,
    isAuto: true,
    data: JSON.parse(localStorage.getItem("user")),
  };

  useEffect(() => {
    if (enableErrorLog) {
      if (error) {
        localStorage.setItem("error", JSON.stringify(errorObj));
        // Acá vas a insertar el error en la base de datos
        // insertError({ variables: { errorLogInput: errorObj } });
        window.location.href = "/error";
        enviado.current = true;
      }
    }
  }, [error]);

  return null;
}

function fallbackRender({ error }) {
  return <ErrorLog error={error} />;
}

document.fonts.ready.then(() => {
  document.fonts.forEach((font) => {
    font.load();
  });
});

root.render(
  <ErrorBoundary fallbackRender={fallbackRender} onReset={(details) => {}}>
    <StrictMode>
      <UserProvider>
        <BrowserRouter>
          <SoftUIControllerProvider>
            <MessageManagerProvider>
              <App />
            </MessageManagerProvider>
          </SoftUIControllerProvider>
        </BrowserRouter>
      </UserProvider>
    </StrictMode>
  </ErrorBoundary>
);
